import React from 'react';
import { Checkbox, Form, Text, Well } from '@adobe/react-spectrum';
import { PlatformType } from 'app/views/components/dialogs/publish/platform';
import { PublishingWell } from 'app/views/components/dialogs/publish/platforms/common/PublishingWell';
export const PublishWell = () => (React.createElement(PublishingWell, { platform: PlatformType.Annotely },
    React.createElement(Well, null,
        React.createElement(Text, null,
            "Image will be published on ",
            React.createElement("b", null, "annotely.com"),
            " cloud storage"),
        React.createElement(Form, null,
            React.createElement(Checkbox, { isSelected: true, isDisabled: true }, "Public"),
            React.createElement(Checkbox, { isDisabled: true },
                "Autoremoval after ",
                React.createElement("b", null, "24 hours"))))));
